module.exports = __webpack_public_path__ + "img/icon-instagram.c0e68dcf.svg";